import objectsUtil from "./objectsUtil";

class profileService {
    constructor(options) {
        const opt = options || {};
        this.profile = opt.profile;
        this.user = opt.user;
    }

    getDefaultDestination() {
        const profile = this.profile || {};
        const user = this.user || {};
        const defaults = this._getSetsDefault(profile);
        const destSets = this._getDestinationSets(profile, user);
        for (let idx = 0; idx < destSets.length; idx++) {
            const s = destSets[idx];
            if (defaults[s] !== undefined) {
                return defaults[s];
            }
        }
        console.log(
            "missing destinations from profile",
            objectsUtil.plain(profile)
        );
        return undefined;
    }

    processDestinations(fnMapper) {
        this.getDestinations().forEach(d => fnMapper(d.id, d));
    }

    getDestinations() {
        const profile = this.profile || {};
        const user = this.user || {};
        const destSets = this._getDestinationSets(profile, user);

        const destinations = profile.destinations || {};
        const r = destSets
            .filter(s => destinations[s] !== undefined)
            .map(s => destinations[s])
            .flat();
        return r;
    }

    getContentTypes() {
        const profile = this.profile || {};
        if (profile) {
            const objectTypes = profile["object-type"];
            if (objectTypes) {
                return objectTypes;
            }
        }
        console.log(
            "missing object-types from profile",
            objectsUtil.plain(profile)
        );
        return {};
    }

    getFixedFields() {
        const profile = this.profile || {};
        if (profile) {
            const fields = profile["fields"];
            if (fields) {
                return fields;
            }
        }
        return {};
    }

    getUserFields() {
        const user = this.user || {};
        let name = undefined;
        if (user.firstname || user.surname) {
            if (user.firstname) {
                name = user.firstname;
            }
            if (name !== undefined) {
                name += " ";
            }
            name += user.surname;
        }
        if (name === undefined) {
            name = user.loginName;
        }
        return {
            name: name,
            loginName: user.loginName,
            workingSites: user.workingSites
        };
    }

    _getDestinationSets(profile, user) {
        const groups = (user.groups || []).map(g => g.name);
        const destConf = profile["destination-configuration"] || {};
        const destGroups = (destConf.groups || []).filter(
            g => groups.indexOf(g.name) >= 0
        );
        const destSets = [];
        destGroups
            .map(g => g.sets)
            .forEach(sets =>
                sets
                    .filter(s => destSets.indexOf(s) < 0)
                    .forEach(s => destSets.push(s))
            );
        return destSets;
    }

    _getSetsDefault(profile) {
        const destConf = profile["destination-configuration"] || {};
        const sets = destConf.sets || [];
        const results = {};
        sets.filter(s => s.name !== undefined)
            .filter(s => s["default-destination-id"] !== undefined)
            .forEach(s => (results[s.name] = s["default-destination-id"]));
        const defaults = profile["default-destination"] || {};
        for (let k in defaults) {
            if (results[k] !== undefined) {
                const d = defaults[k];
                if (d.id !== undefined) {
                    results[k] = d.id;
                }
            }
        }
        return results;
    }
}

export default profileService;
